import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setShowProfileModal } from '../../../../../reduxToolkit/slices/commonSlice';
import { useSelector } from '../../../../../reduxToolkit/typedRedux';
import VyModal from '../../../../common/VyModal';
import ProfileForm from './ProfileForm';
import { FormState } from 'react-hook-form';
import { FieldValues } from 'react-hook-form';

const ProfileFormModal = () => {
  const showProfileModal = useSelector((state) => state.common.showProfileModal);
  const isMobilePreview = useSelector((state) => state.common.isMobilePreview);
  const [formState, setFormState] = useState<FormState<FieldValues>>();

  const dispatch = useDispatch();

  return (
    <VyModal
      hasDefaultPadding={false}
      open={showProfileModal}
      onClose={() => !(formState?.isDirty || formState?.isSubmitting || formState?.isLoading) && dispatch(setShowProfileModal(false))}
      disablePortal={isMobilePreview}>
      {() => <ProfileForm onFormStateChange={setFormState} />}
    </VyModal>
  );
};

export default ProfileFormModal;
